/**
 * Favorites — localStorage-backed favorites list per player instance.
 */

const STORAGE_PREFIX = 'azleentv_favs_';

export class Favorites {
  /**
   * @param {string} uid - Unique player instance ID (used as storage key).
   */
  constructor( uid ) {
    this.key  = STORAGE_PREFIX + uid;
    this._ids = this._load();
  }

  _load() {
    try {
      const raw = localStorage.getItem( this.key );
      return raw ? JSON.parse( raw ) : [];
    } catch {
      return [];
    }
  }

  _save() {
    try {
      localStorage.setItem( this.key, JSON.stringify( this._ids ) );
    } catch { /* quota exceeded — silently ignore */ }
  }

  has( id ) { return this._ids.includes( id ); }
  count()   { return this._ids.length; }
  getAll()  { return [ ...this._ids ]; }

  /**
   * Toggle favorite. Returns new state (true = added).
   * @param {number} id
   * @returns {boolean}
   */
  toggle( id ) {
    const idx = this._ids.indexOf( id );
    if ( idx > -1 ) {
      this._ids.splice( idx, 1 );
      this._save();
      return false;
    }
    this._ids.push( id );
    this._save();
    return true;
  }

  add( id ) {
    if ( ! this.has( id ) ) { this._ids.push( id ); this._save(); }
  }

  remove( id ) {
    this._ids = this._ids.filter( ( i ) => i !== id );
    this._save();
  }

  clear() { this._ids = []; this._save(); }
}
